// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/materialize.min.css
// module id = 430
// module chunks = 11